import { render, staticRenderFns } from "./ListaAudits.vue?vue&type=template&id=2bc9d423"
import script from "./ListaAudits.vue?vue&type=script&lang=js"
export * from "./ListaAudits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports